import React, { useEffect } from 'react';
import ProductRates from '../../components/product-rates';

const ProductRatesDetails = ({
  appointments,
  onPrevTab,
  goToLastTab,
  goBackToCertainTab,
  tabsCount,
  setTab,
  tabValue,
  quoteType,
  veriskIsLoading,
  redirectToStep,
}: AppComponents.ProductRatesProps) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    // eslint-disable-next-line
  }, []);

  return (
    <div className='container'>
      <ProductRates
        veriskIsLoading={veriskIsLoading}
        appointments={appointments}
        onPrevTab={onPrevTab}
        goToLastTab={goToLastTab}
        goBackToCertainTab={goBackToCertainTab}
        tabsCount={tabsCount}
        setTab={setTab}
        tabValue={tabValue}
        quoteType={quoteType}
        redirectToStep={redirectToStep}
      />
    </div>
  );
};

export default ProductRatesDetails;
